import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { logger } from '@/utils/logger';
import useEventCollector from '@/hooks/context/EventCollector/useEventCollector';
import oAuthClient from './core';

export function useAuth() {
  const queryClient = useQueryClient();
  const { reset } = useEventCollector();

  const keycloakLogout = useCallback(
    (redirect: string) => {
      reset();
      sessionStorage.clear();
      queryClient.clear();

      logger.info('[useAuth][keycloakLogout] redirecting', { redirect });
      window.location.assign(oAuthClient.createLogoutUrl(redirect));
    },
    [reset, queryClient],
  );

  return {
    keycloakLogout,
  };
}
